// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_page,
        /* Optional */
        loadProductFirst: true,
        numberFilterTree: 2,
    },
};

// Declare Templates
var bcSfFilterTemplate = {
    'borderClass': 'with-border',
    'productCardAlt': 'product-card-alt',

    // Grid Template
    'productGridItemHtml': '<li class="product product-{{itemId}} {{itemCycleClass}}">' +
                                '<div class="product-inner {{itemProductCardAlt}}">' +
                                    '<figure style="background-image:url(\'{{itemThumbUrl}}\')">' +
                                        '<img class="full-img" alt="{{itemTitle}}" src="{{itemThumbUrl}}">' +
                                        '<a href="{{itemUrl}}" class="{{itemBorderClass}} product-link"></a>' +
                                        '{{itemHover}}' +
                                        '{{itemLabels}}' +
                                    '</figure>' +
                                    '<div class="product-card-details">' +
                                        '{{itemVendor}}' +
                                        '<h2 class="title"><a href="{{itemUrl}}" class="product-link">{{itemTitle}}</a></h2>' +
                                        '{{itemPrice}}' +
                                    '</div>' +
                                '</div>' +
                            '</li>',

    // Pagination Template
    'previousActiveHtml': '<li class="previous"><a href="{{itemUrl}}">' + bcSfFilterConfig.label.pagination_prev + '</a></li>',
    'previousDisabledHtml': '<li class="previous">' + bcSfFilterConfig.label.pagination_prev + '</li>',
    'nextActiveHtml': '<li class="next"><a href="{{itemUrl}}">' + bcSfFilterConfig.label.pagination_next + '</a></li>',
    'nextDisabledHtml': '<li class="next">' + bcSfFilterConfig.label.pagination_next +  '</li>',
    'pageItemHtml': '<li class="jump-to-link"><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
    'pageItemSelectedHtml': '<li class="jump-to-link active">{{itemTitle}}</li>',
    'pageItemRemainHtml': '<li class="jump-to-link ellipsis"><span>{{itemTitle}}</span></li>',
    'paginateHtml': '{{previous}}{{pageItems}}{{next}}',
  
    // Sorting Template
    'sortingHtml': '<label>' + bcSfFilterConfig.label.sorting + ' <span class="sort-dropdown"><select class="sort-by-box-okay">{{sortingItems}}</select><svg class="svg-icon icon-down-arrow"><use xlink:href="#icon-down-arrow"></use></svg></span></label>'
};

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
    /*** Prepare data ***/
    var images = data.images_info;
    data.price_min *= 100, data.price_max *= 100, data.compare_at_price_min *= 100, data.compare_at_price_max *= 100; // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/

    // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;

    // Add custom class
    var itemCycleClass = (index % 4  == 0 || index == 1) ? 'flush' : '';
    var itemBorderClass = bcSfFilterConfig.custom.image_borders ? bcSfFilterTemplate.borderClass : '';
    var itemProductCardAlt = bcSfFilterConfig.custom.enable_alt_product_card ? bcSfFilterTemplate.productCardAlt : '';
    itemHtml = itemHtml.replace(/{{itemCycleClass}}/g, itemCycleClass);
    itemHtml = itemHtml.replace(/{{itemBorderClass}}/g, itemBorderClass);
    itemHtml = itemHtml.replace(/{{itemProductCardAlt}}/g, itemProductCardAlt);

    // Add Thumbnail
    var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src']) : bcSfFilterConfig.general.no_image_url;
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

    // Build Price
    var itemPriceHtml = '';
    if (data.available) {
        if (onSale) {
            itemPriceHtml += '<p class="price sale"><span class="original money">' + this.formatMoney(data.compare_at_price_min, this.moneyFormat) + '</span> <span class="money">' + this.formatMoney(data.price_min, this.moneyFormat) + '</span></p>';
        } else {
            itemPriceHtml += '<p class="price"><span class="money">' + this.formatMoney(data.price_min, this.moneyFormat) + '</span></p>';
        }
    } else {
        itemPriceHtml += '<p class="price">' + bcSfFilterConfig.label.sold_out + '</p>';
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add Hover Item
    var itemHoverHtml = '';
    if (bcSfFilterConfig.custom.enable_alt_product_card) {
        itemHoverHtml += '<a class=" centering-wrapper overlay product-link" href="{{itemUrl}}"';
        if (bcSfFilterConfig.custom.enable_quick_shop) {
            itemHoverHtml += ' data-quickshop-id="{{itemId}}"';
        }
        itemHoverHtml += '><span class="product-card-details-overlay">';
        if (bcSfFilterConfig.custom.show_brand_names) {
            itemHoverHtml += '<h3 class="brand">' + data.vendor + '</h3>';
        }
        itemHoverHtml += '<h2 class="title">{{itemTitle}}</h2>';
        itemHoverHtml += itemPriceHtml;
        itemHoverHtml += '</span></a>';
    } else {
        if (bcSfFilterConfig.custom.enable_quick_shop) {
            itemHoverHtml += '<div class="overlay quickshop-trigger" data-quickshop-id="{{itemId}}">';
            itemHoverHtml += '<span class="label">' + bcSfFilterConfig.label.quick_shop + '</span>';
            itemHoverHtml += '</div>';
        }
    }
    itemHtml = itemHtml.replace(/{{itemHover}}/g, itemHoverHtml);

    // Add Labels
    var itemLabelsHtml = '';
    if (data.available) {
        itemLabelsHtml += '<div class="badges-wrapper">';
        if (onSale) {
            itemLabelsHtml += '<span class="badge badge-sale">' + bcSfFilterConfig.label.sale + '</span>';
        }
        if (data.tags !== null && data.tags.indexOf(bcSfFilterConfig.label.new) > -1) {
            itemLabelsHtml += '<span class="badge badge-new">' + bcSfFilterConfig.label.new + '</span>';
        }
        itemLabelsHtml += '</div>';
    } else {
        itemLabelsHtml += '<div class="badges-wrapper">';
        itemLabelsHtml += '<span class="badge badge-soldout">';
        if (data.tags !== null && data.tags.indexOf('BIS') > -1) {
            itemLabelsHtml += bcSfFilterConfig.label.join_waitlist;
        } else {
            itemLabelsHtml += bcSfFilterConfig.label.sold_out;
        }
        itemLabelsHtml += '</span></div>';
    }
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabelsHtml);

    // Add Vendor
    var itemVendorHtml = '';
    if (bcSfFilterConfig.custom.show_brand_names) {
        itemVendorHtml += '<h3 class="brand"><a href="' + this.buildProductItemVendorUrl+ '">' + data.vendor + '</a></h3>';
    }
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

    return itemHtml;
};

// Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData = function(data) {
    for (var k in data) {
        // Add Options
        var optionsArr = [];
        for (var i in data[k]['options_with_values']) {
            optionsArr.push(data[k]['options_with_values'][i]['name']);
        }
        data[k]['options'] = optionsArr;

        // Customize variants
        for (var i in data[k]['variants']) {
            var variantOptionArr = [];
            var count = 1;
            var variant = data[k]['variants'][i];
            // Add Options
            var variantOptions = variant['merged_options'];
            if (Array.isArray(variantOptions)) {
                for (var j = 0; j < variantOptions.length; j++) {
                    var temp = variantOptions[j].split(':');
                    data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];
                    data[k]['variants'][i]['option_' + temp[0]] = temp[1];
                    variantOptionArr.push(temp[1]);
                }
                data[k]['variants'][i]['options'] = variantOptionArr;
            }
            data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;
            data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100;
        }

        // Add Description
        data[k]['description'] = data[k]['body_html'];
    }
    return data;
};

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
    // Get page info
    var currentPage = parseInt(this.queryParams.page);
    var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

    // If it has only one page, clear Pagination
    if (totalPage == 1) {
        jQ(this.selector.bottomPagination).html('');
        return false;
    }

    if (this.getSettingValue('general.paginationType') == 'default') {
        var paginationHtml = bcSfFilterTemplate.paginateHtml;

        // Build Previous
        var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
        previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
        paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

        // Build Next
        var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml :  bcSfFilterTemplate.nextDisabledHtml;
        nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
        paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

        // Create page items array
        var beforeCurrentPageArr = [];
        for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
            beforeCurrentPageArr.unshift(iBefore);
        }
        if (currentPage - 4 > 0) {
            beforeCurrentPageArr.unshift('...');
        }
        if (currentPage - 4 >= 0) {
            beforeCurrentPageArr.unshift(1);
        }
        beforeCurrentPageArr.push(currentPage);

        var afterCurrentPageArr = [];
        for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
            afterCurrentPageArr.push(iAfter);
        }
        if (currentPage + 3 < totalPage) {
            afterCurrentPageArr.push('...');
        }
        if (currentPage + 3 <= totalPage) {
            afterCurrentPageArr.push(totalPage);
        }

        // Build page items
        var pageItemsHtml = '';
        var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
        for (var iPage = 0; iPage < pageArr.length; iPage++) {
            if (pageArr[iPage] == '...') {
                pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
            } else {
                pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
            }
            pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
            pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
        }
        paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

        jQ(this.selector.bottomPagination).html(paginationHtml);
    }
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content 
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            jQ(this.selector.topSorting).html(html);

            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
        }
    }
};

// Build Breadcrumb
BCSfFilter.prototype.buildBreadcrumb = function(colData, apiData) {
    if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
        var colInfo = colData.collection;
        var breadcrumbHtml = '<span><a href="/">Home</a></span>';
        breadcrumbHtml += '<span class="sep">/</span> ';
        breadcrumbHtml += '<span><a href="/collections">' + bcSfFilterConfig.label.breadcrumb_collection + '</a></span> ';
        breadcrumbHtml += '<span class="sep">/</span> ';
        breadcrumbHtml += '<span>' + colInfo.title + '</span>';
        jQ('.breadcrumb-navigation').html(breadcrumbHtml);
    }
};

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {
    // Build content for Quick view
    if (bcSfFilterConfig.custom.enable_quick_shop) {
        jQ('.product-inner').each(function (e) {
            var _this = this;
            var url = jQ(this).find(".product-link").attr("href");
            jQ.ajax({
                type: "GET",
                url: url + '?view=quickview',
                success: function(data){
                    jQ(_this).append(jQ(data));
                }
            });
        });

        jQ(function() {
            return new QuickShopView();
        });
    }
};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
  this.buildRobotsMetaTag();};

// Show Filter Tree on Mobile
BCSfFilter.prototype.buildFilterTreeMobileButtonEvent = function() {
    var _this = this;
    jQ(this.selector.filterTreeMobileButton).unbind('click');
    jQ(this.selector.filterTreeMobileButton).on('click', function() {
        jQ('#bc-sf-filter-tree2').slideToggle();
        // Re-initialize jscrollpane
        _this.buildFilterScrollbar();
    });
}

function buildDefaultLink(a,b){var c=window.location.href.split("?")[0];return c+="?"+a+"="+b}BCSfFilter.prototype.buildDefaultElements=function(a){if(bcSfFilterConfig.general.hasOwnProperty("collection_count")&&jQ("#bc-sf-filter-bottom-pagination").length>0){var b=bcSfFilterConfig.general.collection_count,c=parseInt(this.queryParams.page),d=Math.ceil(b/this.queryParams.limit);if(1==d)return jQ(this.selector.pagination).html(""),!1;if("default"==this.getSettingValue("general.paginationType")){var e=bcSfFilterTemplate.paginateHtml,f="";f=c>1?bcSfFilterTemplate.hasOwnProperty("previousActiveHtml")?bcSfFilterTemplate.previousActiveHtml:bcSfFilterTemplate.previousHtml:bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml")?bcSfFilterTemplate.previousDisabledHtml:"",f=f.replace(/{{itemUrl}}/g,buildDefaultLink("page",c-1)),e=e.replace(/{{previous}}/g,f);var g="";g=c<d?bcSfFilterTemplate.hasOwnProperty("nextActiveHtml")?bcSfFilterTemplate.nextActiveHtml:bcSfFilterTemplate.nextHtml:bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml")?bcSfFilterTemplate.nextDisabledHtml:"",g=g.replace(/{{itemUrl}}/g,buildDefaultLink("page",c+1)),e=e.replace(/{{next}}/g,g);for(var h=[],i=c-1;i>c-3&&i>0;i--)h.unshift(i);c-4>0&&h.unshift("..."),c-4>=0&&h.unshift(1),h.push(c);for(var j=[],k=c+1;k<c+3&&k<=d;k++)j.push(k);c+3<d&&j.push("..."),c+3<=d&&j.push(d);for(var l="",m=h.concat(j),n=0;n<m.length;n++)"..."==m[n]?l+=bcSfFilterTemplate.pageItemRemainHtml:l+=m[n]==c?bcSfFilterTemplate.pageItemSelectedHtml:bcSfFilterTemplate.pageItemHtml,l=l.replace(/{{itemTitle}}/g,m[n]),l=l.replace(/{{itemUrl}}/g,buildDefaultLink("page",m[n]));e=e.replace(/{{pageItems}}/g,l),jQ(this.selector.pagination).html(e)}}if(bcSfFilterTemplate.hasOwnProperty("sortingHtml")&&jQ(this.selector.topSorting).length>0){jQ(this.selector.topSorting).html("");var o=this.getSortingList();if(o){var p="";for(var q in o)p+='<option value="'+q+'">'+o[q]+"</option>";var r=bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g,p);jQ(this.selector.topSorting).html(r);var s=void 0!==this.queryParams.sort_by?this.queryParams.sort_by:this.defaultSorting;jQ(this.selector.topSorting+" select").val(s),jQ(this.selector.topSorting+" select").change(function(a){window.location.href=buildDefaultLink("sort_by",jQ(this).val())})}}};
/* boost-start-2.4.2 */
/* If you upgrade the lib to the version >= 2.4.2, please comment the functions below out */
BCSfFilter.prototype.buildRobotsMetaTag = function(data) { var self = this; var metaContent = 'meta[content="noindex,nofollow"]'; if (self.checkIfPFParamsPartOfAURL() === true && jQ('head').find( metaContent).length === 0) { var m = document.createElement('meta'); m.name = 'robots'; m.content = 'noindex,nofollow'; document.head.appendChild(m); } }; BCSfFilter.prototype.checkIfPFParamsPartOfAURL = function() { var self = this; if (window.location.search.length > 0 && window.location.search.indexOf('pf_') > 0) { return true; } return false; };
/* boost-end-2.4.2 */

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
